import { Component, OnInit } from '@angular/core';
import { LogService } from 'src/app/services/log/log.service';
import { RouterService } from 'src/app/services/router/router.service';
import { LogEvent } from './../../../interfaces/log';

@Component({
  selector: 'app-mbti-create-alert',
  template: `
    <div class="modal-container">
      <div class="header">안내</div>
      <div class="description">서베이 / 애스크에 참여하기 위해서는 1회 이상 성격 유형 퀴즈를 완료해야 합니다.</div>
      <button class="description2-alt2 white" click [elementName]="'confirm'" (throttledClick)="onClickStartQuiz()">성격 유형 퀴즈 시작하기<i class="arrow-icon fas fa-arrow-right"></i></button>
    </div>
  `,
  styles: [`
    .modal-container {
      padding: 1.375rem 1.25rem 1rem;
    }
    .header {
      font-weight: 700;
      font-size: 1.25rem;
      line-height: 1.75rem;
      letter-spacing: -0.04em;
      color: var(--shade-80);
    }
    .description {
      margin-top: 1.375rem;
      font-weight: 400;
      font-size: 1.125rem;
      line-height: 1.875rem;
      letter-spacing: -0.02em;
      color: var(--shade-80);
    }
    button {
      border-radius: 6px;
      margin-top: 1.5rem;
      padding: 15px;
      width: 100%;
      background-color: var(--blue-70);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .arrow-icon {
      margin-left: 0.5rem;
      font-weight: 900;
      font-size: 1rem;
      line-height: 1.125rem;
      color: var(--white);
    }
  `],
})
export class MbtiCreateAlertComponent implements OnInit {
  constructor(private logService: LogService, private routerService: RouterService) {
    
  }

  ngOnInit(): void {
    this.logService.eventLogging(LogEvent.MBTI_REQUIREMENT_MODAL_VIEWED);
  }

  onClickStartQuiz(): void {
    this.logService.eventLogging(LogEvent.MBTI_REQUIREMENT_MODAL_START_BUTTON_CLICKED);
    this.routerService.navigate('quiz/create');
  }
}